// extracted by css-extract-rspack-plugin
export default {"pillar":"ContentfulIntroPillars-module__pillar__SP4Ky"};